<template>
  <div class="videoCon">
    <div class="videoConWap">
      <div class="videoConWapList" v-for="(item,index) in list" :key="index" @click="goDetails(item)">
        <div class="videoConImg">
          <div class="vCimg">
            <img v-lazy="item.poster" alt="图片"/>
          </div>
          <div class="vCgo">
            <img src="@/assets/playvideo.png" alt />
          </div>
        </div>
        <div class="vCtxt" :style="{color:pageSetup.background==1?'#42476C':'#cccccc'}">{{item.name}}</div>
      </div>
      <div style="width:387px;height:0"></div>
    <div style="width:387px;height:0"></div>
    <div style="width:387px;height:0"></div>
    <div style="width:387px;height:0"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  computed: {
        pageSetup() {
            return this.$store.state.pageSetup
        }
    },
  props:{
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    itemClickHandler: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    goDetails(item){
      if (typeof this.itemClickHandler === "function") {
        this.itemClickHandler(item);
        return;
      }

        const { href } = this.$router.resolve({
          path: "/videosDetails",
          query: { id: item.id }
        });
        window.open(href, '_blank');
      // this.$router.push({path:"/videosDetails" , query:{ id : item.id}})
    }
  }
};
</script>

<style scoped lang="less">
.videoConWap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .videoConWapList {
    width: 387px;
    margin: 0 0 20px;
    cursor: pointer;
    .vCtxt {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      // font-weight: 600;
      color: rgba(66, 71, 108, 1);
      line-height: 16px;
      margin-top: 14px;
    }
    .videoConImg {
      width: 100%;
      height: 218px;
      position: relative;
      .vCgo {
        width: 32px;
        height: 32px;
        position: absolute;
        right: 21px;
        bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .vCimg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: burlywood;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: transform 1.5s;
        }
      }
      .vCimg img:hover{
        transform: scale(1.1);
      }
    }
  }
}
</style>
